import { render, staticRenderFns } from "./ThreadPlaceholder.vue?vue&type=template&id=3460a452&"
import script from "./ThreadPlaceholder.vue?vue&type=script&lang=js&"
export * from "./ThreadPlaceholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports